/**
 * Categories Management Page
 *
 * Manage product categories with hierarchical structure.
 *
 * Features:
 * - List all categories
 * - Create/Edit/Delete categories
 * - Hierarchical tree view
 * - Sync from JTL
 *
 * WCAG 2.1 Level AA + BFSG konform
 */

import { FolderTree, Plus, RefreshCw } from 'lucide-react';
import {
  Button,
  Card,
  CardHeader,
  CardContent,
  EmptyState,
} from '@/components/v2/ui';

export function Categories() {
  return (
    <div className="min-h-screen bg-neutral-50 dark:bg-neutral-900">
      {/* Header */}
      <header className="border-b border-neutral-200 dark:border-neutral-800 bg-white dark:bg-neutral-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="p-2 rounded-lg bg-green-100 dark:bg-green-900/30">
                <FolderTree className="h-6 w-6 text-green-600 dark:text-green-400" />
              </div>
              <div>
                <h1 className="text-2xl font-bold text-neutral-900 dark:text-neutral-50">
                  Kategorien
                </h1>
                <p className="text-sm text-neutral-500 dark:text-neutral-400 mt-0.5">
                  Verwalte Produktkategorien und Hierarchien
                </p>
              </div>
            </div>

            <div className="flex items-center gap-2">
              <Button
                variant="outline"
                size="sm"
                title="Kategorien von Integrationen synchronisieren (JTL, Shopify, etc.)"
              >
                <RefreshCw className="h-4 w-4 mr-2" />
                Sync Kategorien
              </Button>
              <Button
                variant="primary"
                size="sm"
              >
                <Plus className="h-4 w-4 mr-2" />
                Neue Kategorie
              </Button>
            </div>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <Card>
          <CardHeader>
            <h2 className="text-lg font-semibold text-neutral-900 dark:text-neutral-50">
              Alle Kategorien
            </h2>
          </CardHeader>

          <CardContent>
            <EmptyState
              title="Noch keine Kategorien"
              description="Erstelle deine erste Kategorie oder synchronisiere von Integrationen"
              icon={<FolderTree className="h-12 w-12" />}
              action={
                <Button variant="primary" size="sm">
                  <Plus className="h-4 w-4 mr-2" />
                  Erste Kategorie erstellen
                </Button>
              }
            />
          </CardContent>
        </Card>
      </main>
    </div>
  );
}
